var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('player-resource-log-copy-link',{attrs:{"playerId":_vm.action.playerId,"copyId":_vm.action.copyId,"lable":"resource log copy"}})}
var staticRenderFns = []

export { render, staticRenderFns }